export default "__VITE_PUBLIC_ASSET__741c9d20__"